<template>
  <div class="common-padding-left common-padding-right">
    <div class="row">
      <div class="col col-12 col-md-3 col-lg-3"><SideBar :dataList="dataList" /></div>
      <div class="col col-12 col-md-9 col-lg-9 common-padding-top">
        <h1>子商户查询</h1>
        <p></p>
        <h4>接口说明</h4>
        <div class="font-12 common-padding-bottom-2">
          <div><span class="font-weight-bold">测试URL：</span><span>http://test.api.route.hangmuxitong.com</span></div>
          <div><span class="font-weight-bold">生产URL：</span><span>https://api.yunfastpay.com</span></div>
          <div><span class="font-weight-bold">请求方式：</span><span>POST</span></div>
        </div>
        <h4>请求参数</h4>
        <table class="table table-bordered table-striped">
          <thead>
          <tr>
            <th>参数名</th>
            <th>变量</th>
            <th>类型</th>
            <th>是否必填</th>
            <th>说明</th>
          </tr>
          </thead>
          <tbody class="font-12">
          <tr><td>交易码</td><td>trscode</td><td>String（32）</td><td>是</td><td>AGM0207</td></tr>
          <tr><td>机构号</td><td>orgCd</td><td>String（32）</td><td>是</td><td></td></tr>
          <tr><td>外部商户号</td><td>outMchtCd</td><td>String（15）</td><td>是</td><td>outMchtCd与mchtCd必须二选一</td></tr>
          <tr><td>商户编号</td><td>mchtCd</td><td>String(15)</td><td>是</td><td>outMchtCd与mchtCd必须二选一</td></tr>
          <tr><td>产品编号</td><td>proCd</td><td>String(15)</td><td>是</td><td>固定：mcht</td></tr>
          <tr><td>费率通道</td><td>chanelType</td><td>String(32)</td><td>是</td><td>固定：1</td></tr>
          <tr><td>状态查询</td><td>checkStatus</td><td>String(32)</td><td>是</td><td>查询审核状态：Y，查询商户信息:N</td></tr>
          </tbody>
        </table>
        <h4>请求示例</h4>
        <p>
          <code>
            {
            "trscode":"AGM0207",
            "orgCd":"201806077798594",
            "mchtCd":"MCHT100011611",
            "proCd":"mcht",
            "chanelType":"1",
            "checkStatus":"Y"
            }
          </code>
        </p>
        <h4>应答参数</h4>
        <table class="table table-bordered table-striped">
          <thead>
          <tr>
            <th>参数名</th>
            <th>变量</th>
            <th>类型</th>
            <th>是否必填</th>
            <th>说明</th>
          </tr>
          </thead>
          <tbody class="font-12">
          <tr><td>应答码</td><td>respCode</td><td>String（12）</td><td>是</td><td>成功：0000  失败：非0000，具体失败查看描述</td></tr>
          <tr><td>应答描述</td><td>respMsg</td><td>String（512）</td><td>是</td><td>对应应答码信息描述，包含中文</td></tr>
          <tr><td>商户状态</td><td>mchtStatus</td><td>String（2048）</td><td>是</td><td>0成功，1处理中，3，审核拒绝（原因参考应答描述）</td></tr>
          <tr><td>渠道信息</td><td>qrData</td><td>JSON</td><td>否</td><td></td></tr>
          <tr><td>渠道类型</td><td>childNoType</td><td>JSON</td><td>否</td><td>WX微信，ZFB支付宝</td></tr>
          <tr><td>渠道子商户号</td><td>childNo</td><td>JSON</td><td>否</td><td>渠道子商户号</td></tr>
          <tr><td>报备状态</td><td>repoStatus</td><td>JSON</td><td>否</td><td>01 成功，02 失败</td></tr>
          <tr><td>接入方渠道号</td><td>channelId</td><td>JSON</td><td>否</td><td></td></tr>
          <tr><td>报备失败原因</td><td>errMessage</td><td>JSON</td><td>否</td><td></td></tr>
          <tr><td>支付宝等级</td><td>aliLevel</td><td>JSON</td><td>否</td><td></td></tr>
          <tr><td>商户全称</td><td>mchtName</td><td>String（150）</td><td>否</td><td>身份证名字</td></tr>
          <tr><td>角色</td><td>mchtRole</td><td>String（3）</td><td>否</td><td>固定600:商户</td></tr>
          <tr><td>商户简称</td><td>mchtCnAbbr</td><td>String（60）</td><td>否</td><td>身份证名字</td></tr>
          <tr><td>联系人姓名</td><td>contact</td><td>String（30）</td><td>否</td><td>身份证名字</td></tr>
          <tr><td>联系人类型</td><td>contactClass</td><td>String（30）</td><td>否</td><td>法人：LEGAL_PERSON</td></tr>
          <tr><td>联系人客户电话</td><td>commMobil</td><td>String（20）</td><td>否</td><td>商户自己手机号码</td></tr>
          <tr><td>联系人电话</td><td>commTel</td><td>String（20）</td><td>否</td><td>商户自己手机号码</td></tr>
          <tr><td>法人姓名</td><td>manager</td><td>String（50）</td><td>否</td><td>身份证名字</td></tr>
          <tr><td>法人证件类型</td><td>artifCertifTp</td><td>String（2）</td><td>否</td><td>身份证：00</td></tr>
          <tr><td>法人证件号码</td><td>identityNo</td><td>String（20）</td><td>否</td><td>身份证号码</td></tr>
          <tr><td>法人联系电话</td><td>managerTel</td><td>String（12）</td><td>否</td><td>商户自己手机号码</td></tr>
          <tr><td>证件类型</td><td>licenseType</td><td>String（32）</td><td>否</td><td>身份证：NATIONAL_IDENTITY</td></tr>
          <tr><td>商户证件编号号码</td><td>licenceNo</td><td>String（20）</td><td>否</td><td>身份证号码</td></tr>
          <tr><td>商户证件有效期</td><td>licenceEndDate</td><td>String（8）</td><td>否</td><td>身份证有效期</td></tr>
          <tr><td>注册地址</td><td>regAddr</td><td>String（60）</td><td>否</td><td>个人填住址</td></tr>
          <tr><td>营业性质</td><td>busType</td><td>String（60）</td><td>否</td><td>3：自然人</td></tr>
          <tr><td>外部商户号</td><td>outMchtCd</td><td>String（15）</td><td>否</td><td></td></tr>
          <tr><td>商户结算帐户开户行</td><td>settleBankNo</td><td>String（40）</td><td>否</td><td>开户支行号</td></tr>
          <tr><td>商户结算帐户开户行名称</td><td>settleBankNm</td><td>String（256）</td><td>否</td><td>开户支行名称</td></tr>
          <tr><td>商户结算帐户号</td><td>settleAcct</td><td>String（40）</td><td>否</td><td>银行卡号</td></tr>
          <tr><td>商户结算帐户户名</td><td>settleAcctNm</td><td>String（256）</td><td>否</td><td>身份证名字</td></tr>
          <tr><td>账户类型</td><td>acctType</td><td>String（1）</td><td>否</td><td>1 ：对私</td></tr>
          <tr><td>开户地址</td><td>openAcctAddr</td><td>String（512）</td><td>否</td><td>开户的省市，如：广东广州</td></tr>
          </tbody>
        </table>
        <h4>应答示例</h4>
        <p>
          <code>{
          "mchtCd": "MCHT100011611",
          "mchtStatus": "0",
          "qrData": "[{\"childNoType\":\"YL-QRC\",\"childNo\":\"QRC310105981426\",\"repoStatus\":\"01\",\"channelId\":\"\",\"errMessage\":\"成功\"},{\"childNoType\":\"WX\",\"childNo\":\"426167137\",\"repoStatus\":\"01\",\"channelId\":\"393395513\",\"errMessage\":\"成功\"},{\"childNoType\":\"ZFB\",\"childNo\":\"2088110160242694\",\"aliLevel\":\"INDIRECT_LEVEL_M3\",\"repoStatus\":\"01\",\"channelId\":\"2088531229750653\",\"errMessage\":\"成功\"}]",
          "chnlSettleRate": "1",
          "channelSecMchtNo": "399200730374753",
          "respMsg": "交易成功",
          "respCode": "0000"
          }</code>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from '@/pages/interface/components/SideBar'
export default {
  name: 'App',
  components: {
    SideBar
  },
  data () {
    return {
      dataList: [
        {'url': '/interface/zshbj', 'name': '子商户报件'},
        {'url': '/interface/xwzshbj', 'name': '小微子商户报件'},
        {'url': '/interface/tpsc', 'name': '图片上传'},
        {'url': '/interface/zshktcp', 'name': '子商户开通产品'},
        {'url': '/interface/zshcx', 'name': '子商户开通查询'},
        {'url': '/interface/zshbbcx', 'name': '子商户报备查询'},
        {'url': '/interface/zshfzxy', 'name': '子商户分账协议签署'},
        {'url': '/interface/zshpz', 'name': '子商户业务配置'},
        {'url': '/interface/zshhd', 'name': '子商户回调'}]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/interface/components/Zshcx.vue